<template>
<v-autocomplete
  v-model="select"
  :items="items"
  :loading="loading"
  :search-input.sync="search"
  hide-no-data
  no-filter
  return-object

  :menu-props="{ offsetY: true, fixed: true }"
  :label="$t('Standort')"
  :placeholder="placeholder"

  no-data-text="Keine passenden Orte gefunden"
  attach
  @change="change"
  filled

  clearable
></v-autocomplete>
</template>

<script>
import { GeocoderFactory } from "./Geocoder";

const DEBOUNCE = 150;

export default {
  name: "GeocoderAutocomplete",

  props: [
    "value",
    "placeholder",
    "hide-details"
  ],

  data() {
    return {
      loading: false,
      search: null,
      select: null,
      items: []
    };
  },

  created() {
    // je Komponenteninstanz: Debounce-Timer, Geocoder und Zähler der jüngsten Anfrage
    this.timer = null;
    this.requestSeq = 0;
    this.destroyed = false;
    this.geocoder = null;
    this.geocoderReady = GeocoderFactory().then(geocoder => {
      this.geocoder = geocoder;
      return geocoder;
    });
  },

  beforeDestroy() {
    this.destroyed = true;
    this.invalidate();
  },

  watch: {
    search(val) {
      if (!val) {
        this.invalidate();
        this.items = [];
        return;
      }

      if (this.select && typeof this.select === "object" && val === this.select.text) {
        return;
      }

      this.querySelections(val);
    },

    value(val) {
      if (val) {
        this.select = val;
      }
    }
  },

  methods: {
    // beendet Timer und laufende Anfrage und macht verspätete Antworten wirkungslos
    invalidate() {
      this.requestSeq++;

      if (this.timer != null) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      if (this.geocoder) {
        this.geocoder.cancelAutocomplete();
      }

      this.loading = false;
    },

    querySelections(value) {
      this.invalidate();

      const seq = this.requestSeq;
      const current = () => !this.destroyed && seq === this.requestSeq;

      this.loading = true;

      this.timer = setTimeout(() => {
        this.timer = null;

        this.geocoderReady.then(geocoder => {
          if (!current()) {
            return null;
          }

          return geocoder.autocomplete(value);
        }).then(items => {
          if (current() && Array.isArray(items)) {
            this.items = items.slice();
          }
        }).catch(() => {
          if (current()) {
            this.items = [];
          }
        }).then(() => {
          if (current()) {
            this.loading = false;
          }
        });
      }, DEBOUNCE);
    },

    change(o) {
      this.invalidate();
      this.items = o ? [o] : [];
      this.$emit("change", o);
    }
  }
};
</script>
